<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Select Document</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="m-0">
  <div class="row com-doc-head eip-mt-20">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 ml-3 ">
          <mat-button-toggle-group aria-label="Document Type" class="" [value]='docType' (change)="onDocTypeChange($event.value)">
              <mat-button-toggle value="Repository">Repository Document</mat-button-toggle>
              <mat-button-toggle value="Workflow">Workflow Document</mat-button-toggle>
          </mat-button-toggle-group>
      </div>
  </div>
  <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
          <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="gridView" [selectable]="true" (selectionChange)="onSelectionChange($event)" [skip]="skip" kendoGridSelectBy="itemIndex" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true" [height]="550">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div>
                      <input placeholder="Search in all  documents..." style="width: 100%;margin-top: 1%;" kendoTextBox (input)="onFilterRD($event.target.value)" />
                  </div>
              </ng-template>
              <kendo-grid-checkbox-column showSelectAll="true" width="60">
              </kendo-grid-checkbox-column>
              <kendo-grid-column field="documentNo" title="Document No" [width]="200">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">{{dataItem.documentNo}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="title" title="Title" [width]="250">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.title}}" eipTooltipPosition="auto">{{dataItem.title}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="revision" title="Revision" [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="createdByName" title="Created By" [width]="150">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.createdByName}}" eipTooltipPosition="auto">{{dataItem.createdByName}}</span>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary mt-2 " style="float:right;margin-right: 14px;" (click)="postData()"><i class="fa fa-arrow-right-lg" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Select Documents</button>
  </div>
</div>